// extracted by mini-css-extract-plugin
export default {"game-name":"QtCd6e_ZeQXyj2SgvLcw","game-name-inner":"uBCk5w6hacoDyeX5nsrn","type-default":"qoBpHsnHniqKW8OUE9x4","common_bganimation":"gdhxUjm0FtLliwm_3tm4"};